import React from 'react';
import {
  UserInfoBlock,
  ProfileName,
  ProfileRoleBadge,
  ProfileAddress,
} from './Styles';
import { getRoleDisplayName, LABELS } from './constants';
import type { UserInfoSectionProps } from './types';

const UserInfoSection: React.FC<UserInfoSectionProps> = ({
  name,
  username,
  role,
  address,
}) => {
  const displayName = name || username || '—';
  const displayRole = getRoleDisplayName(role);
  const displayAddress = address || LABELS.LOCATION;

  return (
    <UserInfoBlock>
      <ProfileName level={3}>{displayName}</ProfileName>
      <ProfileRoleBadge>{displayRole}</ProfileRoleBadge>
      <ProfileAddress>{displayAddress}</ProfileAddress>
    </UserInfoBlock>
  );
};

export default React.memo(UserInfoSection);
